export const get = (key: string): number[] => {
    const carIds = [];
    const match = document.cookie.match(new RegExp(key + '=([^;]+)'));
    if (!match || !match[1]) {
        return carIds;
    }
    const carUserPairs = decodeURIComponent(match[1]).split(',');
    carUserPairs.forEach(pair => {
        const id = +(pair.split(':')[0]);
        if (id && !isNaN(id)) {
            carIds.push(id);
        }
    });
    return carIds;
};
